import { useCallback } from 'react';

import { config } from '@/config/api.config';
import { useAuth } from '@/contexts/auth/AuthContext';

export const useSendTaxExemptionsInstructions = () => {
  const { personalAccount, user } = useAuth();
  const payload = {
    data: {
      type: 'event',
      attributes: {
        properties: {
          account_id: personalAccount?.id,
        },
        metric: {
          data: {
            type: 'metric',
            attributes: {
              name: 'Tax Exemptions Instructions Requested',
              service: 'project-service',
            },
          },
        },
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email: user?.email,
            },
          },
        },
      },
    },
  };

  return useCallback(async () => {
    if (!personalAccount?.id || !user?.email) {
      return {
        error: 'No personal account or user email found',
      };
    }
    const response = await fetch(
      'https://a.klaviyo.com/client/events?company_id=' +
        config.klaviyoPublicApiKey,
      {
        method: 'POST',
        headers: {
          revision: '2024-10-15',
        },
        body: JSON.stringify(payload),
      },
    );

    if (!response.ok) {
      return {
        error: response.statusText,
      };
    }

    return {
      success: [200, 201].includes(response.status),
    };
  }, [personalAccount?.id, user?.email]);
};
